import React, {Component} from 'react';
import './Header.css';
import logo from '../../img/numbers.svg';
import {NavLink, Link} from "react-router-dom";

export default class HeaderHtml extends Component {

    render() {
        return (
            <header>
                <div className="container">
                    <div className="Header_content">
                        <Link className="Header_logo" to={"/Home"}>
                            <img src={logo} alt={""}/>
                            <div>Numbers</div>
                        </Link>

                        <div className="Header_nav">
                            <NavLink  to="/Home">HOME</NavLink>
                            <NavLink  to="/Api-reference">API REFERENCE </NavLink>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
